/**
 * Company selectors of the report, contract and cover (Luis, Nov 4). They wait
 * until what the page holds is what the database holds. Until the customer's
 * first batch lands every record looks like a blank one: no company, no state,
 * so the menu lists every state's companies and an existing company reads as
 * "pick one".
 *
 * Never for good (V45): a failed read or the timeout opens them again, as they
 * were before this rule, so a stalled load cannot strand the rep.
 */
export const COMPANY_SELECTOR_TIMEOUT_MS = 10000

export interface CompanySelectorLoad {
  companiesLoaded: boolean
  /** Undefined until the database answers. */
  dbCompany: string | undefined
  dbState: string | undefined
  failed: boolean
  storeCompany: string
  storeState: string
  timedOut: boolean
}

export const companySelectorReady = ({
  companiesLoaded,
  dbCompany,
  dbState,
  failed,
  storeCompany,
  storeState,
  timedOut,
}: CompanySelectorLoad): boolean =>
  timedOut ||
  failed ||
  (companiesLoaded && dbCompany === storeCompany && dbState === storeState)
